<template>
  <b-container>
    <b-row v-if="items.length" class="m-2">
      <h4>We wish to recruit <b> (1)</b> suitably qualified, adaptable and result-oriented candidates for the following positions:</h4>
    </b-row>

    <b-row v-if="!items.length" tag="article" style="width: 100%;" class="mb-2 mt-4">
      <b-container fluid class="d-flex align-items-center justify-content-center">
        <b-row>
          <b-col class="text-center">
            <h3 style="color: red;">We're sorry, but the application deadline for all positions has passed. No further applications are being accepted at this time. Please check back later for future opportunities.</h3>
          </b-col>
        </b-row>
      </b-container>

    </b-row>
    <b-card v-for="item in items" :key="item.id" :title="item.job_title" tag="article" style="width: 100%;" class="mb-2">
      <b-card-text>
        <b-row class="secondary mx-auto">
          <b-col cols="2" @click="navigateToJob(item.name)">
            <b-row>
              <b> NO.</b>
            </b-row>
            <b-row>
              {{ item.planned_vacancies }}
            </b-row>
          </b-col>
          <b-col @click="navigateToJob(item.name)">
            <b-row>
              <b> Job Category</b>
            </b-row>
            <b-row>
              {{ item.department }}
            </b-row>
          </b-col>
          <b-col @click="navigateToJob(item.name)">
            <b-row>
              <b> Closing Date</b>
            </b-row>
            <b-row>
              {{ item.closing_date.split(' ')[0] }} 5.00 PM
            </b-row>
          </b-col>
          <b-col class="d-none d-sm-block">
            <b-row>
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-primary" class="mr-1"
                style="height:45px" @click="navigateToJob(item.name)">
                View Details
              </b-button>
              <apply-job :job-id="item.name" style="height:45px" class="ml-1" />
            </b-row>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
  </b-container>
</template>

<script>
import {
  BContainer, BCard, BRow, BCol, BButton,
} from 'bootstrap-vue'
import { isUserLoggedIn } from '@/auth/utils'
import useJwt from '@/auth/jwt/useJwt'
import ApplyJob from './ApplyJob.vue'

export default {
  components: {
    BContainer,
    BCard,
    BRow,
    BCol,
    BButton,
    ApplyJob,
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        {
          key: 'id', label: 'Id',
        },
        { key: 'post', label: 'Designation', sortable: true },
        { key: 'category', label: 'Category', sortable: true },
        'job_group',
        { key: 'start_date', label: 'Deadline', sortable: true },
        { key: 'experience', label: 'No of Posts', sortable: true },
      ],
      /* eslint-disable global-require */
      items: [],
      /* eslint-disable global-require */
      status: [{
        1: 'Current', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        1: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
  },
  created() {
    this.getJobList()
  },
  methods: {
    getJobList() {
      useJwt.jobOpenings({}).then(response => {
        this.items = response.data.message
      }).catch(error => alert(JSON.stringify(error)))
    },
    onRowSelected(items) {
      alert(JSON.stringify(items))
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    navigateToJob(id) {
      this.$router.push({ name: 'careers-single-job', params: { id } })
    },
    applyForJob(id) {

      console.log('com on guys'+id)
      if (!isUserLoggedIn) {
        this.$router.push({ name: 'auth-login' })
        return
      }
      this.$router.push({ name: 'careers-single-job', params: { id } })
    },
  },
}
</script>
